import * as React from 'react';
import { Redirect, Route as ReactRoute } from 'react-router-dom';
import { Container } from 'typescript-ioc/es5';
import { BetterComponent } from '../../components/better-component/better-component';
import { AppState } from '../../stores/app';
import { Switch, Route } from '../../components/router';
import {
    Login,
    ForgotPassword,
    ResetPassword,
    ConfirmUser,
} from './';
import './pre-auth.scss';
import { GAHelper } from '../../components/ga-helper/ga-helper';

interface IProps {}

interface IState {}

export class PreAuth extends BetterComponent<IProps, IState> {
    private appState: AppState;

    public constructor(props: IProps) {
        super(props);

        this.appState = Container.get(AppState);
    }

    public render() {
        return this.appState.appIsLoading ? ('') : (
            <div className="module pre-auth">

                {!this.appState.isAuthenticated && (
                    <ReactRoute path="/" component={() => GAHelper(this.appState)} />
                )}

                <Switch>
                    <Route
                        preAuth={true}
                        path="/login"
                        exact={true}
                        component={Login}
                    />
                    <Route
                        preAuth={true}
                        path="/confirm(-invite)?"
                        exact={true}
                        component={ConfirmUser}
                    />
                    <Route
                        preAuth={true}
                        path="/reset-password"
                        exact={true}
                        component={ResetPassword}
                    />
                    <Route
                        preAuth={true}
                        path="/forgot-password"
                        exact={true}
                        component={ForgotPassword}
                    />

                    {!this.appState.isAuthenticated && (
                        <Redirect
                            from="/"
                            exact={true}
                            to="/login"
                        />
                    )}
                </Switch>
            </div>
        );
    }
}
